import { render } from "./NewUser.vue?vue&type=template&id=6bfcf2ae"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=6bfcf2ae&lang=scss"

import exportComponent from "E:\\code\\libra-3rd\\yuexinting-jiading\\yxt-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__